import { CheckCircle as CheckCircleIcon, CheckCircleOutline as CheckCircleOutlineIcon } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

import { BrandProfileField, BrandProfileFieldName, BrandProfilePayload } from 'domains/brand/types';

import {
    BRAND_PROFILE_FIELD_DISPLAY_ORDER,
    CHECKLIST_LABELS,
    getFieldValue,
    isFieldSatisfied,
} from './brandLearningStrengthUtils';

export type BrandLearningStrengthChecklistProps = {
    brandProfile: BrandProfileField[];
    formValues?: BrandProfilePayload;
};

const BrandLearningStrengthChecklist = ({ brandProfile, formValues }: BrandLearningStrengthChecklistProps) => (
    <Stack spacing={1} sx={{ pt: 2 }}>
        {[...brandProfile]
            .sort(
                (a, b) =>
                    (BRAND_PROFILE_FIELD_DISPLAY_ORDER.indexOf(a.fieldName as BrandProfileFieldName) ?? 999) -
                    (BRAND_PROFILE_FIELD_DISPLAY_ORDER.indexOf(b.fieldName as BrandProfileFieldName) ?? 999)
            )
            .map((field) => {
                const value = getFieldValue(field, formValues);
                const satisfied = isFieldSatisfied(value, field.fieldName);
                const label = CHECKLIST_LABELS[field.fieldName as BrandProfileFieldName] ?? field.fieldName;

                return (
                    <Stack key={field.fieldName} direction="row" alignItems="center" justifyContent="space-between">
                        <Stack direction="row" alignItems="center" spacing={1}>
                            {satisfied ? (
                                <CheckCircleIcon sx={{ fontSize: 20, color: 'teal' }} />
                            ) : (
                                <CheckCircleOutlineIcon sx={{ fontSize: 20, color: 'gray' }} />
                            )}
                            <Typography variant="body2">
                                {label}
                                {!field.isRequired && (
                                    <Typography
                                        component="span"
                                        variant="helperText"
                                        color="text.secondary"
                                        sx={{ ml: 1 }}
                                    >
                                        Optional
                                    </Typography>
                                )}
                            </Typography>
                        </Stack>
                        <Typography variant="body2" color="text.secondary">
                            + {field.weightage}%
                        </Typography>
                    </Stack>
                );
            })}
    </Stack>
);

export default BrandLearningStrengthChecklist;
